import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Col, Row } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import ModalMessage from '../../shared/components/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import "moment/locale/es";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import MCADAailableTimesList from './MCADAailableTimesList';
import MCADAailableTimesListActions from './MCADAailableTimesListActions';
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../shared/components/Modal';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

var user = sessionStorage.getItem('usuario');
user = JSON.parse(user);

class RescheduleAdmisionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.props.date,
            errors: {},
            isLoading: false,
            availableTimes: [],
            confirmedCitas: [],
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' },
            activitySelected: this.props.services[0].id_servicio,
            costumer_data: null,
            costumer: null,
            plans: [],
            plan: null,
            activitiesPriceList: [],
            activitiesAppointment: [],
            colorAlertModal: "",
            messagAlerteModal: "",
            showAlertModal: false,
            typeAgendaList: [],
            typeAgenda: null
        };
    };

    componentDidMount() {
        this.loadTypeAgendas();
        //this.verifyAvailableTimes(this.props.date, this.props.services[0].id_servicio);
    }

    verifyAvailableTimes = async (dateFilter, serviceFilter) => {
        if (dateFilter != null && dateFilter != undefined && serviceFilter != undefined && serviceFilter != null) {
            this.setState({ isLoading: true });
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/buscar-disponibilidad', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ fecha: dateFilter, id_servicio: serviceFilter, tipo_agenda: this.state.typeAgenda })
            }).then(response => {
                return response.json();
            }).then(data => {
                this.setState({ availableTimes: data, isLoading: false });
            }).catch((error) => {
                this.setState({ isLoading: false });
                console.error('Error:', error);
                this.setState({ openAlert: true, modalAlert: { color: 'danger', title: "Error de Filtros", message: "Ha ocurrido un error buscando las Jornadas Disponibles del dia seleccionado" } });
            });
        }
    }

    handlerConfirmedCitas = async (value) => {
        value.id_servicio = this.props.services[0].id_servicio;
        value.detalle_servicio = this.props.services[0];
        //value.excepcion_cobro = await this.validateControlAppointment(value);
        this.setState({ confirmedCitas: [...this.state.confirmedCitas.filter(confCita => value.id_servicio != confCita.id_servicio), value] }, () => {
            
        });
    }

    validateAgendaConfirmedSome = (id_jornada, id_agenda) => {
        let finded = this.state.confirmedCitas.some(con => con.id_jornada == id_jornada && con.id_agenda == id_agenda);
        return finded;
    }

    confirmChangesReschedule = async () => {
        let clinica = JSON.parse(sessionStorage.getItem('clinica'));
        let dataReschedule = {
            id_admision: this.props.id_admision,
            citas_confirmadas: this.state.confirmedCitas,
            id_usuario: user != null && user != undefined ? user.id_usuario : JSON.parse(sessionStorage.getItem('usuario')).id_usuario,
            isTheServicePaid: !!clinica ? clinica.hasOwnProperty('cobro_consulta_control') ? clinica.cobro_consulta_control : false : false
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/reagendar-admision', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataReschedule)
        }).then(response => {
            if (response.status != 500 && response.status != 403 && response.status != 404) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({
                colorAlertModal: "success",
                messagAlerteModal: "Admisión Reagendada Correctamente",
                showAlertModal: true
            });
        }).catch((error) => {
            this.setState({
                colorAlertModal: "danger",
                messagAlerteModal: "Ha ocurrido un error Reagendando la Admisión, es posible que esta Jornada ya este ocupada por otro paciente",
                showAlertModal: true
            },() => {
                this.verifyAvailableTimes(this.state.date, this.state.activitySelected);
            });
            console.error('Error:', error);
        });
    }

    onOkModal = () => {
        switch (this.state.colorAlertModal) {
            case "success":
                this.setState({
                    colorAlertModal: "",
                    messagAlerteModal: "",
                    showAlertModal: false
                }, () => {
                    this.props.closeModalRescheduleAdmision();
                });
                break;
            case "warning":
                this.confirmChangesReschedule();
                break;
            case "danger":
                this.setState({
                    colorAlertModal: "",
                    messagAlerteModal: "",
                    showAlertModal: false
                });
                break;
        }
    }

    onToggleModal = () => {
        switch (this.state.colorAlertModal) {
            case "success":
                this.setState({
                    colorAlertModal: "",
                    messagAlerteModal: "",
                    showAlertModal: false
                }, () => {
                    this.props.closeModalRescheduleAdmision();
                });

                break;
            case "warning":
                this.setState({
                    colorAlertModal: "",
                    messagAlerteModal: "",
                    showAlertModal: false
                });
                break;
            case "danger":
                this.setState({
                    colorAlertModal: "",
                    messagAlerteModal: "",
                    showAlertModal: false
                });
                break;
        }
    }

    loadTypeAgendas = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}atencion/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error');
            }
        }).then(data => {
            this.setState({ typeAgendaList: data });
        }).catch(err => {
            this.setState({ typeAgendaList: [] });
        });
    }

    validateControlAppointment = (appointmentData) => {
        return new Promise((resolve, reject) => {
            if (appointmentData.detalle_servicio.codigo.substr(0, 4) == "8903") {
                let services = [appointmentData.detalle_servicio]
                let dataSend = {
                    id_historia: this.props.id_historia,
                    servicios: services,
                    fecha_inicio: this.state.date,
                    id_agenda: appointmentData.id_agenda
                }
                console.log(dataSend)
                fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/validar-cita-control', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(dataSend)
                }).then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error('Ha ocurrido un error con la Validación');
                    }
                }).then(data => {
                    resolve(data.excento);
                }).catch((error) => {
                    resolve(false);
                });
            }
            else {
                resolve(false);
            }
        });
    }

    render() {

        const ListAilable = () => {
            return (<MCADAailableTimesList
                reactTableData={this.state.availableTimes}
                ReactTableActions={MCADAailableTimesListActions}
                updating={false}
                handlerConfirmedCitas={this.handlerConfirmedCitas}
                validateAgendaConfirmedSome={this.validateAgendaConfirmedSome}
            />);
        }

        return (
            <Fragment>
                <Modal
                    open={this.props.openModalRescheduleAdmision}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                    disableEnforceFocus={true}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <h4 className="bold-text">Reagendar Cita</h4>
                        <label>Seleccione la Fecha y el Servicio para ir Filtrando la Disponibilidad</label>

                        <Row>
                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <DatePicker
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            variant="static"
                                            label="Fecha"
                                            autoOk={true}
                                            disableToolbar={true}
                                            value={this.state.date}
                                            onChange={(date) => {
                                                this.setState({ date: date }, () => {
                                                    this.verifyAvailableTimes(date, this.state.activitySelected);
                                                });
                                            }}
                                            format="DD/MM/yyyy"
                                            animateYearScrolling
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>

                                <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true,
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    <InputLabel shrink={true} id="select-type-agenda-label">Tipo de Agenda</InputLabel>
                                    <Select
                                        labelId="select-type-agenda-label"
                                        id="select-type-agenda"
                                        value={this.state.typeAgenda}
                                        onChange={(event) => {
                                            this.setState({ typeAgenda: event.target.value }, () => {
                                                this.verifyAvailableTimes(this.state.date, this.state.activitySelected);
                                            })
                                        }}
                                    >
                                        {this.state.typeAgendaList.map((typeA, index) => {
                                            return <MenuItem key={typeA.id_atencion} value={typeA.id_atencion}>{typeA.atencion}</MenuItem>
                                        })}
                                    </Select>
                                    <FormHelperText>{this.state.errors.type_agenda}</FormHelperText>
                                </FormControl>

                                <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true,
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    <InputLabel shrink={true} id="services-reassign-label">Servicios</InputLabel>
                                    <Select
                                        labelId="services-reassign-label"
                                        id="services-reassign"
                                        disabled={this.state.typeAgenda == null}
                                        value={this.state.activitySelected}
                                        onChange={(event) => {
                                            this.setState({ activitySelected: event.target.value }, () => {
                                                this.verifyAvailableTimes(this.state.date, event.target.value);
                                            })
                                        }}
                                    >
                                        {this.props.services.map((activity, index) => {
                                            return <MenuItem key={activity.id_servicio} value={activity.id_servicio}>{`${activity.codigo} - ${activity.nombre}`}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Col>
                            <Col md={8}>
                                <ListAilable />
                            </Col>
                        </Row>

                        <div style={{ marginTop: 10, display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>

                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                onClick={() => {
                                    this.props.returnAgenda();
                                }}
                            >
                                Cerrar
                            </Button>

                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                color='primary'
                                onClick={() => {
                                    this.setState({
                                        colorAlertModal: "warning",
                                        messagAlerteModal: "Esta completamente seguro de Reagendar esta admisión?",
                                        showAlertModal: true
                                    });
                                }}
                            >
                                Reagendar
                            </Button>
                        </div>
                    </div>
                </Modal>


                <AlertModal
                    color={this.state.colorAlertModal}
                    title={this.state.messagAlerteModal}
                    modal={this.state.showAlertModal}
                    onOk={() => {
                        this.onOkModal();
                    }}
                    toggle={() => {
                        this.onToggleModal();
                    }}
                />
            </Fragment>);
    }
}

export default RescheduleAdmisionModal;
